import { createApp, defineAsyncComponent } from 'vue'
import PrimeVue from '@/js/services/primevue'

export default class VueComponents {
  constructor(container = document) {
    const components = container.querySelectorAll('[data-vue-component]')
    const apps = []

    components.forEach((component) => {
      const vueComponent = defineAsyncComponent(() =>
        import(`./vue/${component.dataset.vueComponent}.vue`)
      )

      if (vueComponent) {
        const app = createApp(vueComponent)
        PrimeVue(app)

        app.provide('dataset', component.dataset)
        app.mount(component)
        apps.push(app)
      }
    })

    return apps
  }
}
